import { render } from "./otherHisSubject.vue?vue&type=template&id=1670b531&scoped=true"
import script from "./otherHisSubject.vue?vue&type=script&lang=js"
export * from "./otherHisSubject.vue?vue&type=script&lang=js"

import "./otherHisSubject.vue?vue&type=style&index=0&id=1670b531&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1670b531"]])

export default __exports__